module.exports = __webpack_public_path__ + "static/media/upp_flo_fal_arr.5f344a64.png";